import React from "react";
import TopBanner from "@/components/TopBanner";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Services from "@/components/Services";
import Materials from "@/components/Materials";
import QuoteForm from "@/components/QuoteForm";
import Gallery from "@/components/Gallery";
import WhyChoose from "@/components/WhyChoose";
import Contact from "@/components/Contact";
import StickyMobileCall from "@/components/StickyMobileCall";

export default function LandingPage() {
  return (
    <main className="velvet-cream text-[#0A1228]">
      <TopBanner />
      <Navigation />
      <Hero />
      <TrustBar />
      <Services />
      <Materials />
      <QuoteForm />
      <Gallery />
      <WhyChoose />
      <Contact />
      <StickyMobileCall />
    </main>
  );
}
